
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { appImages, appVideos } from "../../../../../../../Media.ts";
import CommonReactGUIElementsFactory from "../../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory.tsx";
import { IModalVideoControllerReturn } from "../../../../../../../commonreact/main/components/modals/modalvideo/ModalVideoController.ts";
import ImageSlideGallery from "../../../../../../../commonreact/main/components/gallerys/image/ImageSlideGallery.tsx";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ef: CommonReactGUIElementsFactory;
  mvc: IModalVideoControllerReturn;
}

export const AndroidAppImageGalleryCard: React.FC<IProps> = (props): JSX.Element => {

  const tag = "AndroidAppImageGalleryCard.tsx";
  console.log(tag + "START");
  const height = props.dsc.screenHeight()
  //const height = 100
  
  const r: number = 1048/500;
  const imageItems = [
    { src: appImages.is_ionian_c, ratio: r },
    { src: appImages.is_classic_ion_sixte_ajoute, ratio: r },
    { src: appImages.mixer_classic_sixte_ajoute, ratio: r },
    { src: appImages.is_rock_aeo_i_vi_ii_vii, ratio: r },
    { src: appImages.tt_rock_is_aeo_i_vi_ii_vii, ratio: r },
    { src: appImages.p_proglist, ratio: r },
    { src: appImages.is_classic_aeo_quintfall, ratio: r },
    { src: appImages.mixer_classic_quintfall, ratio: r },
    { src: appImages.is_blues_mix_rock_n_roll, ratio: r },
    { src: appImages.mixer_blues_mix_rock_n_roll, ratio: r },
    { src: appImages.mm_jazz_ii_vi_i, ratio: r },
    { src: appImages.mixer_jazz_aeo_ii_vi_i, ratio: r },
    { src: appImages.p_tt_jazz_aeo_ii_vi_i, ratio: r },
    { src: appImages.bpm, ratio: r },
    { src: appImages.hm_rock_phrygian_ii_vi_i, ratio: r },
    { src: appImages.is_rock_aeo_scale, ratio: r },
    { src: appImages.p_tt_rock_scale_aeo, ratio: r }
  ];

  return (
    <CardWrapper
      dsc={props.dsc}
      header={<h3>App-Image-Gallery</h3>}
    >
      <div className="flex flex-col">
        <div className={`mt-5`}>
          <ImageSlideGallery height={height} dsc={props.dsc}  images={imageItems} />
        </div>
        <div className="mt-5">
        </div>
      </div>
    </CardWrapper>
  )
}